import {IApiRoute} from '../../../@interfaces/services/Database';
import {HTTPMethods} from '../../../@interfaces/http/HTTPMethods';
import AbstractModel from './AbstractModel';

export default class ApiRoute extends AbstractModel<IApiRoute> implements IApiRoute {
	name!: string;
	uri!: string;
	methods!: HTTPMethods[];

	protected get table() {
		return this.connection.apiRoutes;
	}
}
